import React from 'react';
import Icon from './AppIcon';

const AgentStatusIndicator = ({ 
  status = 'offline', 
  agentName = 'Agent',
  size = 'default',
  showLabel = true,
  showIcon = false,
  className = ''
}) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case 'active':
        return {
          color: 'bg-success',
          label: 'Active',
          icon: 'CheckCircle2',
          description: 'Agent is online and ready'
        };
      case 'busy':
        return {
          color: 'bg-warning',
          label: 'Busy',
          icon: 'Clock',
          description: 'Agent is processing tasks'
        };
      case 'offline':
        return {
          color: 'bg-muted-foreground',
          label: 'Offline',
          icon: 'XCircle',
          description: 'Agent is not available'
        };
      default:
        return {
          color: 'bg-muted-foreground',
          label: 'Unknown',
          icon: 'HelpCircle',
          description: 'Agent status unknown'
        };
    }
  };

  const getSizeClasses = (size) => {
    switch (size) {
      case 'sm':
        return {
          dot: 'w-1.5 h-1.5',
          text: 'text-xs',
          icon: 12
        };
      case 'lg':
        return {
          dot: 'w-3 h-3',
          text: 'text-base',
          icon: 20
        };
      default:
        return {
          dot: 'w-2 h-2',
          text: 'text-sm',
          icon: 16
        };
    }
  };

  const config = getStatusConfig(status);
  const sizeClasses = getSizeClasses(size);

  return (
    <div 
      className={`inline-flex items-center gap-2 ${className}`}
      role="status"
      aria-label={`${agentName} status: ${config?.label}`}
      title={config?.description}
    >
      {showIcon ? (
        <Icon 
          name={config?.icon} 
          size={sizeClasses?.icon} 
          className={`${config?.color?.replace('bg-', 'text-')}`}
        />
      ) : (
        <span 
          className={`
            ${sizeClasses?.dot} 
            ${config?.color} 
            rounded-full 
            agent-status-indicator
            ${status === 'active' ? 'agent-status-active' : ''}
            ${status === 'busy' ? 'agent-status-busy' : ''}
            ${status === 'offline' ? 'agent-status-offline' : ''}
          `}
        />
      )}
      {showLabel && (
        <span className={`font-medium font-caption ${sizeClasses?.text} text-foreground`}>
          {config?.label}
        </span>
      )}
    </div>
  );
};

export default AgentStatusIndicator;